import classNames from 'classnames';
import React from 'react';
import { CloseIcon } from '../../ui/icons/icons';

type TModal = {
  children: React.ReactNode;
  closePopup: React.MouseEventHandler<HTMLElement>;
  openPopup: boolean;
};

const Modal: React.FC<TModal> = ({ children, closePopup, openPopup }) => {
  return (
    openPopup && (
      <section className="modal-body flex justify-center">
        <section className="fixed left-0 top-0 z-50 flex h-full w-full flex-col bg-black900/[0.59] md:gap-8">
          <section
            className={classNames(
              'absolute left-1/2 top-1/2 w-11/12 -translate-x-1/2 -translate-y-1/2 overflow-auto p-6 px-4',
              'rounded-xl bg-white',
              'md:h-auto md:w-[600px] md:min-w-[600px] md:p-6'
            )}
          >
            <section className={classNames('flex flex-row-reverse')}>
              <figure role="none" onClick={closePopup} className="inline-block cursor-pointer">
                <CloseIcon width={24} height={24} />
              </figure>
            </section>
            {children}
          </section>
        </section>
      </section>
    )
  );
};

export default Modal;
